import React from 'react';

import Button from '../../../../components/Button';

type ButtonProps = {
  onClick: () => void;
}

const ButtonNewCollaborator = ({ onClick }: ButtonProps) => {

  return (
    <Button
      onClick={onClick}
    >
      Novo Colaborador
    </Button>
  )
}

export default ButtonNewCollaborator;